const settings = {
  server: 'https://smp.aapico.com', //
  scanner: 'http://agrtrack01.aapico.com',
};

export default settings;
